import { Button } from "@mui/material";
import { memo } from "react";
import { useDispatch } from "react-redux";
import { APIActions } from "../../api/actions";
import DialogAlert from "../../classes/DialogAlert";
import { getExpensesByResult } from "../../modals/expenses/failed-resume/utils";
import { removeManyAdvances } from "../../store/features/advancesSlice";
import { setError } from "../../store/features/base/errorBaseSlice";
import { openElement } from "../../store/features/base/modalsSlice";
import { openSnackbar } from "../../store/features/base/snackbarBaseSlice";
import { removeManyExpenses } from "../../store/features/expensesSlice";
import { removeManyTravels } from "../../store/features/travelsSlice";

const role = "approver";

const renderTitle = (num = 0) => ({
  travels: {
    title: num > 1 ? `Aprovar ${num} viagens` : "Aprovar viagem",
  },
  expenses: {
    title: num > 1 ? `Aprovar ${num} despesas` : "Aprovar despesa",
  },
  advances: {
    title: num > 1 ? `Aprovar ${num} adiantamentos` : "Aprovar adiantamento",
  },
});

const ApproveButton = ({
  ids = [],
  onApprove = () => {},
  type = "expenses",
}) => {
  const dispatch = useDispatch();

  const handleClick = (e) => {
    e.stopPropagation();
    DialogAlert.show({
      disableCloseButton: true,
      title: renderTitle(ids?.length)[type]?.title,
      actions: [
        { text: "Cancelar" },
        {
          main: true,
          text: "Aprovar",
          onClick: async () => {
            try {
              if (type === "expenses") {
                const res = await APIActions.expenses.approve({
                  expensesIds: ids,
                  role,
                });

                const { allOk, successNumber, withErrors, failed, successIds } =
                  getExpensesByResult(res);
                if (allOk) {
                  dispatch(
                    openSnackbar({
                      message:
                        successNumber === 1
                          ? "Despesa aprovada"
                          : `${successNumber} despesas aprovadas`,
                    })
                  );
                } else if (withErrors) {
                  dispatch(
                    openElement({
                      name: "modalExpensesFailedResume",
                      payload: {
                        expenses: failed,
                        title: "Algumas despesas não foram aprovadas",
                        role: "approver",
                      },
                    })
                  );
                }

                dispatch(
                  removeManyExpenses({
                    data: successIds,
                    role,
                  })
                );
              } else if (type === "advances") {
                await APIActions.advances.approve({
                  advancesId: ids[0],
                  role,
                });
                dispatch(
                  openSnackbar({
                    message:
                      ids?.length === 1
                        ? "Adiantamento aprovado"
                        : `${ids?.length} adiantamentos aprovados`,
                  })
                );
                dispatch(
                  removeManyAdvances({
                    data: ids,
                    role,
                  })
                );
              } else if (type === "travels") {
                await APIActions.travels.approve({
                  travelId: ids[0],
                  role,
                });
                dispatch(
                  openSnackbar({
                    message:
                      ids?.length === 1
                        ? "Viagem aprovada"
                        : `${ids?.length} viagens aprovadas`,
                  })
                );
                dispatch(
                  removeManyTravels({
                    data: ids,
                    role,
                  })
                );
              }
              onApprove();
            } catch (error) {
              dispatch(
                setError({
                  error,
                })
              );
            }
          },
        },
      ],
    });
  };

  return (
    <>
      <Button
        sx={{
          height: 33,
          fontSize: ".95rem",
          transition: "none",
        }}
        onClick={handleClick}
        color="primary"
        variant="contained"
        disableElevation
      >
        Aprovar {ids.length > 1 ? `(${ids?.length})` : ""}
      </Button>
    </>
  );
};
export default memo(ApproveButton);
